import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    dark: false,
    themes: {
      light: {
        primary: '#1976D2',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        background: '#FAFAFA',
        surface: '#FFFFFF',
        'surface-variant': '#F5F5F5'
      },
      dark: {
        primary: '#2196F3',
        secondary: '#616161',
        accent: '#FF4081',
        error: '#F44336',
        info: '#03DAC6',
        success: '#4CAF50',
        warning: '#FF9800',
        background: '#121212',
        surface: '#1E1E1E',
        'surface-variant': '#2D2D2D'
      }
    }
  },
  options: {
    customProperties: true
  }
}) 